module.exports = flarum.core.compat['common/Model'];